import css from 'styled-jsx/css';
import { gradient, rgba, isRTL } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';
  @import 'src/common/styling/_mixins-scss/vars';

  .DateRangeFormField {
    position: relative;

    .DateRangeFormField__label {
      font-weight: 300;
      font-size: 12px;
      color: rgba(15, 15, 15, 0.5);
      margin: 0 0 2px 0;
    }

    .DateRangeFormField__inner {
      direction: ltr;
      position: absolute;
      z-index: 99;
      background: #fff;
    }

    .DayPicker_weekHeader {
      top: 65px;
      z-index: 0;
    }

    .DayPicker_weekHeader_li {
      font-weight: 500;
      text-transform: uppercase;
      text-align: center;
    }

    .CalendarMonthGrid__horizontal {
      top: 15%;
    }

    .CalendarMonthGrid_month__horizontal {
      &:nth-child(1) {
        display: none;
      }

      &:nth-child(2) {
        .CalendarMonth_caption {
          width: 180px;
          position: absolute;
          z-index: 10 !important;
          top: -35px;
          left: 70px;
        }
      }

      &:nth-child(3) {
        display: none;
      }
    }

    .CalendarMonth_table {
      position: absolute;
      top: 50px;
    }

    .DayPickerNavigation_button {
      z-index: 11 !important;
      top: 5%;

      &:nth-child(1) {
        left: 5%;
      }

      &:nth-child(2) {
        right: 5%;
      }
    }

    .DayPicker_transitionContainer {
      height: 290px !important;
    }

    .DateRangeFormField__years-navigation {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;
      select {
        border: none;
        background: none;
      }
      .Select__value-container {
        font-size: 14px;
        padding: 0 !important;
        width: 50px;
      }
      .Select__control {
        border: none;
      }
      .Select__menu {
        font-size: 14px;
        z-index: 10 !important;
        cursor: pointer;
      }
      .Select__option {
        padding: rem(10px 5px) !important;
      }
      .DateRangeFormField__month-inner {
        > div {
          width: 70px;
          margin-right: 10px;
        }
      }
      .DateRangeFormField__years-inner {
        width: 80px !important;
      }
    }

    .DateRangeFormField__picker {
      display: flex;
      width: 100%;
      align-items: center;
      padding-left: ${isRTL ? '0' : '10px'};
      padding-right: ${isRTL ? '10px' : '0'};
      position: relative;
      transition: all 0.4s ease;
      background-color: transparent;
      border: 1px solid;
      cursor: pointer;
      z-index: 99;
      height: 30px;

      .CalendarIcon {
        svg {
          position: absolute;
          right: rem(${isRTL ? 'auto' : '10px'});
          left: rem(${isRTL ? '10px' : 'auto'});
          top: rem(5px);
          width: 18px;
          height: 17px;
          g {
            path {
              stroke: transparent !important;
            }
          }
        }
      }
    }

    .DateRangeFormField__presets {
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;

      .DefaultButton {
        width: 120px;
        margin: 5px !important;
        padding: 5px 10px;
      }
    }

    .CalendarDay__default {
      border: 1px solid transparent !important;
      font-weight: 500 !important;
      transition: all 0.4s ease !important;
    }

    .CalendarDay__blocked_out_of_range {
      cursor: not-allowed;
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css.global`
    .DateRangeFormField__picker {
      border-radius: ${border.radius};
      border-color: #e9e9e9 !important;
      &.active {
        border-color: ${colors.primary.hex} !important;
        .DateRangeFormField__mobile {
          color: ${colors.black.hex};
        }
        .CalendarIcon {
          svg {
            g {
              path {
                fill: ${colors.primary.hex};
              }
            }
            path {
              stroke: ${colors.primary.hex};
            }
          }
        }
        .DateRangeFormField__picker-text {
          color: ${colors.primary.hex};
        }
      }

      .DateRangeFormField__picker-error {
        border-color: ${colors.error.hex} !important;
        .DateInput_input,
        .DateField__mobile {
          color: ${colors.white.hex} !important;
          &::placeholder {
            color: ${colors.white.hex} !important;
          }
        }
        .CalendarIcon {
          svg {
            g {
              path {
                fill: ${colors.error.hex};
              }
            }
            path {
              stroke: ${colors.error.hex};
            }
          }
        }
      }

      .DateRangeFormField__picker-text {
        color: ${colors.gray.hex};
        font-size: 15px;
      }
    }

    .DateRangeFormField__picker-disabled {
      background: ${colors.disabled.hex};
      .DateRangeFormField__mobile {
        background: ${colors.disabled.hex};
        color: ${colors.disabled.hex};
      }
      .CalendarIcon {
        svg {
          g {
            path {
              fill: ${colors.gray.hex};
            }
          }
          path {
            stroke: ${colors.gray.hex};
          }
        }
      }
      &.haveText {
        .DateRangeFormField__mobile {
          color: ${colors.black.hex};
        }
      }
    }

    .DayPicker_weekHeader {
      color: ${colors.primary.hex};
    }

    .CalendarDay__selected {
      background: ${colors.primary.hex};
      border-color: ${colors.primary.hex};
      &:hover {
        background: ${colors.secondary.hex};
        border-color: ${colors.secondary.hex};
      }
    }

    .DateRangeFormField__error {
      border-color: ${colors.error.hex} !important;
      .DateInput_input,
      .DateRangeFormField__mobile {
        color: ${colors.white.hex} !important;
        &::placeholder {
          color: ${colors.white.hex} !important;
        }
      }
      .CalendarIcon {
        svg {
          g {
            path {
              fill: ${colors.error.hex};
            }
          }
          path {
            stroke: ${colors.error.hex};
          }
        }
      }
      .DateRangeFormField__label {
        color: ${colors.error.hex} !important;
      }
    }

    .CalendarDay__default {
      color: ${colors.gray.hex} !important;
    }

    .CalendarDay__default:hover {
      background: ${rgba([colors.gradientEnd.rgb, 0.25])} !important;
    }

    .CalendarDay__selected {
      background: ${rgba([colors.gradientEnd.rgb, 0.45])} !important;
    }

    .CalendarDay__selected:active,
    .CalendarDay__selected:hover {
      background: ${rgba([colors.gradientEnd.rgb, 0.6])} !important;
    }

    .CalendarDay__selected_span {
      background: ${rgba([colors.gradientEnd.rgb, 0.25])} !important;
      &:hover {
        background: ${rgba([colors.gradientEnd.rgb, 0.45])} !important;
      }
    }

    .CalendarDay__blocked_out_of_range {
      background: ${rgba([colors.lightGray.rgb, 0.4])} !important;
      &:hover {
        background: ${rgba([colors.lightGray.rgb, 0.4])} !important;
      }
    }

    .Calendar__data-info {
      border-radius: ${border.radius};
      border: 1px solid ${colors.primary.hex};
      color: ${colors.primary.hex};
      &:hover {
        border-color: ${rgba([colors.primary.rgb, 0.8])};
        background: ${gradient(53.07, [colors.gradientStart.rgb, 0.15], 0, [colors.gradientEnd.rgb, 0.15], 100)};
        color: ${rgba([colors.primary.rgb, 0.8])};
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
